import { provide as n, inject as s } from "vue";
import { throwError as c } from "./ghl-ui.es877.js";
import { createInjectionKey as i } from "./ghl-ui.es920.js";
const t = i("n-carousel-methods"), p = (o) => {
  n(t, o);
}, l = (o = "unknown", r = "component") => {
  const e = s(t);
  return e || c(o, `\`${r}\` must be placed inside \`n-carousel\`.`), e;
};
export {
  p as provideCarouselContext,
  l as useCarouselContext
};
